/* eslint-disable @typescript-eslint/no-unused-vars */
import styled from '@emotion/styled';
import type { ForwardSurveyProps } from '@hotjar/webapp/features/Surveys/ForwardSurvey';
import type { WidgetPreviewProps } from '@hotjar/feedback/components/common/Wizard/WidgetPreview/WidgetPreview';
import type { WidgetLimitAlertProps } from '../../common/WidgetLimitAlert/WidgetLimitAlert';
import type { DeviceSelectorProps } from '../../common/Wizard/DeviceSelector/DeviceSelector';
import type { DetailsSectionProps } from '../../common/Wizard/Sections/Details/DetailsSection';
import type { SurveyWizardFullScreenHeaderProps } from './Header/SurveyWizardFullScreenHeader';
import type { SurveyWizardHeaderProps } from './Header/SurveyWizardHeader';
import type { SurveyWizardAccordionProps } from './Accordion/SurveyWizardAccordion';
import type { LimitAlertsProps } from '../../common/LimitAlerts/LimitAlerts';

const Container = styled.div`
  height: 100vh;
  width: 100vw;
  overflow: scroll;
  z-index: 1000;
`;

type WizardProps = SurveyWizardFullScreenHeaderProps &
  SurveyWizardHeaderProps &
  Omit<LimitAlertsProps, 'featureGroup' | 'location'> &
  SurveyWizardAccordionProps;

export const SurveyWizard = (props: WizardProps): JSX.Element => {
  return <Container />;
};
